<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Override Element Plus form item layout within editor pages */
.el-form-item__content {
  display: block;
}
</style>
